import { CellText } from './cell-text';

export function CellNotes({ className, text }: { text: string | undefined | null; className?: string }) {
  return <CellText className={`w-72 truncate ${className}`}>{text ?? '—'}</CellText>;
}
